import { atom } from 'recoil';
import { type CustomerModel } from '../types/models/customer-model';

export const userProfileState = atom<CustomerModel | null>({
  key: 'UserProfile',
  default: null
});
